import React, { useState } from 'react';
import { useMap } from 'react-leaflet';
import { LatLngExpression } from 'leaflet';
import './LocationControl.css';

interface LocationControlProps {
    className?: string;
    onLocationFound?: (position: LatLngExpression) => void;
}

const LocationControl: React.FC<LocationControlProps> = ({ className, onLocationFound }) => {
    const map = useMap();
    const [isLocating, setIsLocating] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const handleLocationClick = () => {
        if (!navigator.geolocation) {
            setError('Géolocalisation non supportée par votre navigateur');
            return;
        }

        setIsLocating(true);
        setError(null);

        navigator.geolocation.getCurrentPosition(
            (position) => {
                const { latitude, longitude } = position.coords;
                const userPos: LatLngExpression = [latitude, longitude];
                map.setView(userPos, 15, {
                    animate: true,
                    duration: 1.0
                });
                // Notifier le composant parent de la nouvelle position
                if (onLocationFound) {
                    onLocationFound(userPos);
                }
                setIsLocating(false);
            },
            (err) => {
                let errorMessage = 'Impossible d\'obtenir votre position';
                switch (err.code) {
                    case err.PERMISSION_DENIED:
                        errorMessage = 'Accès à la géolocalisation refusé';
                        break;
                    case err.POSITION_UNAVAILABLE:
                        errorMessage = 'Position non disponible';
                        break;
                    case err.TIMEOUT:
                        errorMessage = 'Délai d\'attente de géolocalisation dépassé';
                        break;
                }
                setError(errorMessage);
                setIsLocating(false);
                console.error('Geolocation error:', err);
            },
            {
                enableHighAccuracy: true,
                timeout: 10000,
                maximumAge: 60000
            }
        );
    };

    return (
        <div className={`location-control ${className || ''}`}>
            <button
                className={`location-button ${isLocating ? 'locating' : ''}`}
                onClick={handleLocationClick}
                disabled={isLocating}
                title={isLocating ? 'Recherche de votre position...' : 'Centrer sur ma position'}
            >
                {isLocating ? (
                    <span className="icon spinning">🔄</span>
                ) : (
                    <span className="icon">📍</span>
                )}
            </button>
            {error && (
                <div className="location-error" title={error}>
                    <span className="icon">⚠️</span>
                </div>
            )}
        </div>
    );
};

export default LocationControl;
